import React, { useRef, useState } from "react";
import Papa from "papaparse";
import { UnoStoreHooks } from "@simulanisindia/ui";
import { DownloadIcon, FileUploadIcon } from "../Icons";
import GroupSampleCSV from '../assets/GroupSampleCSV.csv'
import UserSampleCSV from '../assets/UserSampleCSV.csv'
import apiClient from "../apiClient";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useModalContext } from "./context/ModalProvider";
import { modalName } from "../utils/general";

const { useUnoSelector } = UnoStoreHooks

export const GroupCSVUploadModal = () => {
  const configData = useUnoSelector((state) => state.config);
  const { modalState, openModal, closeModal } = useModalContext();
  const csvData = [];
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");

  const handleOpenModal = (list) => {
    const { handleRefreshTab, params } = modalState;
    openModal({ csvList: list, type: "group", modalName: modalName.TABLE_CSV, handleRefreshTab, params, modalSize: "xl" });
  }

  function toBoolean(value) {
    if (typeof value === "boolean") {
      return value === true;
    }

    if (typeof value === "string") {
      return value.trim().toLowerCase() === "true";
    }

    return false;
  }

  const handleFileUpload = (file) => {

    if (file && file.type === "text/csv") {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          const headers = ["Name"];
          const presentHeaders = result.meta.fields;
          const headersIncluded = headers.every(header => presentHeaders.includes(header));
          if (!headersIncluded) {
            setError("Invalid CSV Format");
            return;
          };
          setFile(file);
          result.data?.forEach((e, i) => {
            const _name = e?.Name ? String(e.Name).trim().replace(/\s+/g, ' ') || null : null;
            const _identifier = e?.Identifier ? String(e.Identifier).trim().replace(/\s+/g, ' ') || null : null;
            const _avatar = e?.Avatar ? String(e.Avatar).trim().replace(/\s+/g, '') || null : null;
            const _handDown = toBoolean(e?.Unristricted);

            const _userName = e?.UserName ? String(e.UserName).trim().replace(/\s+/g, ' ') || null : null;
            const _userEmail = e?.UserEmail ? String(e.UserEmail).trim().replace(/\s+/g, ' ') || null : null;
            const _userDesignation = e?.UserDesignation ? String(e.UserDesignation).trim().replace(/\s+/g, '') || null : null;
            const _userAvatar = e?.UserAvatar ? String(e.UserAvatar).trim().replace(/\s+/g, '') || null : null;
            const _userPhone = e?.UserPhone ? String(e.UserPhone).trim().replace(/\s+/g, '') || null : null;
            const _userUID = e?.UserUID ? String(e.UserUID).trim().replace(/\s+/g, '') || null : null;
            const _userPassword = e?.UserPassword ? String(e.UserPassword).trim().replace(/\s+/g, '') || null : null;

            const finalResult = {
              id: i + 1,
              name: _name,
              identifier: _identifier,
              avatar: _avatar,
              handDown: _handDown,
              typeId: null,
              error: null,
              
              userName: _userName,
              userEmail: _userEmail,
              userDesignation: _userDesignation,
              userAvatar: _userAvatar,
              userPhone: _userPhone,
              userUID: _userUID,
              userPassword: _userPassword,
              role: null,
            };
            csvData.push(finalResult);
          });

          handleOpenModal([...csvData]);
        },
        error: (error) => {
          console.error("CSV Parsing Error:", error);
        },
      });
    } else {
      alert("Please upload a valid CSV file.");
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.currentTarget.classList.add("drag-over");
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.currentTarget.classList.remove("drag-over");
    const droppedFile = event.dataTransfer.files[0];
    if (event.dataTransfer.files.length > 0) {
      handleFileUpload(droppedFile);
    }
  };

  const handleDragLeave = (event) => {
    event.currentTarget.classList.remove("drag-over");
  };

  return (
    <>
      <div className="p-4 upload-csv-modal">
        <div className="csvuploadheader d-flex align-items-center gap-2">
          <div className="filterbtn">
            <div className="btninadjust">
              <FileUploadIcon />
            </div>
          </div>
          <div>
            <h6 className="m-0">Group Upload CSV</h6>
            <p className="m-0">Import your data</p>
          </div>
        </div>

        <div
          className={`fileupload ${file && "bordrgreen"} ${error && "borderred"}`}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          onDragLeave={handleDragLeave}
        >
          <label htmlFor="csvFileInput">
            <div>
              <input type="file" accept=".csv" id="csvFileInput" onChange={(e) => handleFileUpload(e.target.files[0])} />
              <FileUploadIcon />
            </div>
            <div>
              <p>
                Drag & drop or <span>Select File</span> to upload CSV
              </p>
              <p>Supported formats: .csv, Max size: 10MB</p>
            </div>
          </label>
        </div>
        {file && <p className="success text-success">File Uploaded: {file.name}</p>}
        {error && <p className="error text-danger">{error}</p>}
        <div className="required-fields">
          <h6>
            {" "}
            Required Field<span>*</span>
          </h6>
          <p>Name</p>
        </div>

        <div className="modal-footer p-0">
          <p className="link-text">
            <a href={GroupSampleCSV}>
              <DownloadIcon /> CSV Template
            </a>
          </p>
          <div className="modal-footer-btns">
            <button className="cancel" onClick={closeModal}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export const UserCSVUploadModal = () => {
  const configData = useUnoSelector((state) => state.config);
  const { modalState, openModal, closeModal } = useModalContext();
  const csvData = [];
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");

  const handleOpenModal = (list) => {
    const { handleRefreshTab, params } = modalState;
    openModal({ csvList: list, type: "user", modalName: modalName.TABLE_CSV, handleRefreshTab, params, modalSize: "xl" });
  }

  const handleFileUpload = (file) => {
    if (file && file.type === "text/csv") {

      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          const headers = ["Name", "Email", "Designation", "Avatar", "Phone", "Uid", "Password"];
          const presentHeaders = result.meta.fields;
          const headersIncluded = headers.every(header => presentHeaders.includes(header));
          if (!headersIncluded) {
            setError("Invalid CSV Format");
            return;
          };
          setFile(file);
          result.data?.forEach((e, i) => {
            const _avatar = e.Avatar ? String(e.Avatar).trim().replace(/\s+/g, ' ') || null : null;
            const _designation = e.Designation ? String(e.Designation).trim().replace(/\s+/g, ' ') || null : null;
            const _email = e.Email ? String(e.Email).trim().replace(/\s+/g, ' ') || null : null;
            const _name = e.Name ? String(e.Name).trim().replace(/\s+/g, ' ') || null : null;
            const _password = e.Password ? String(e.Password).trim().replace(/\s+/g, ' ') || null : null;
            const _phone = e.Phone ? String(e.Phone).trim().replace(/\s+/g, ' ') || null : null;
            const _uid = e.Uid ? String(e.Uid).trim().replace(/\s+/g, ' ') || null : null;

            const object = {
              id: i + 1,
              avatar: _avatar,
              name: _name,
              email: _email,
              uid: _uid,
              phone: _phone,
              password: _password,
              designation: _designation,
              role: null,
              error: null
            }
            csvData.push(object);
          });

          handleOpenModal([...csvData]);

        },
        error: (error) => {
          console.error("CSV Parsing Error:", error);
        },
      });
    } else {
      alert("Please upload a valid CSV file.");
    }

  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.currentTarget.classList.add("drag-over");
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.currentTarget.classList.remove("drag-over");
    const droppedFile = event.dataTransfer.files[0];
    if (event.dataTransfer.files.length > 0) {
      handleFileUpload(droppedFile);
    }
  };

  const handleDragLeave = (event) => {
    event.currentTarget.classList.remove("drag-over");
  };

  return (
    <>
      <div className="p-4 upload-csv-modal">
        <div className="csvuploadheader d-flex gap-2">
          <div className="filterbtn">
            <div className="btninadjust">
              <FileUploadIcon />
            </div>
          </div>
          <div>
            <h6 className="m-0">Upload User CSV</h6>
            <p className="m-0">Import your data</p>
          </div>
        </div>
        <div
          className={`fileupload ${file && "bordrgreen"} ${error && "borderred"}`}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          onDragLeave={handleDragLeave}
        >
          <label htmlFor="csvFileInput">
            <div>
              <input ref={fileInputRef} type="file" accept=".csv" id="csvFileInput" onChange={(e) => handleFileUpload(e.target.files[0])} />
              <FileUploadIcon />
            </div>
            <div>
              <p>
                Drag & drop or <span>Select File</span> to upload CSV
              </p>
              <p>Supported formats: .csv, Max size: 10MB</p>
            </div>
          </label>
        </div>
        {file && <p className="success text-success">File Uploaded: {file.name}</p>}
        {error && <p className="error text-danger">{error}</p>}
        <div className="required-fields">
          <h6>
            Required Fields<span>*</span>
          </h6>
          <p>Name, Email or UID/Password</p>
        </div>

        <div className="modal-footer p-0">
          <p className="link-text">
            <a href={UserSampleCSV}>
              <DownloadIcon /> CSV Template
            </a>
          </p>
          <div className="modal-footer-btns">
            <button className="cancel" onClick={closeModal}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};